// extracted by mini-css-extract-plugin
module.exports = {"links":"styles-module_links__VNQYH61gh_NWt8SlWK5qN","video":"styles-module_video__Yck3Uc9hI12DHwZoFdUPT"};